<template>
  <router-view />
</template>

<script>
export default {
  name: "app-ruleGroup"
};
</script>

<style lang="scss" scoped></style>
